import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { convertToLineItem,convertToStockItem } from '../../../../util';
import { productsDispatcher, currentNodeState, productState, identityState, combineStates, screenSizeState, currentPageState, combineDispatchers, currentPageDispatcher,priceDispatcher,stockDispatcher } from '../../../../store';
import { ProductsViewer, Selection, SelectionViewer, HtmlComponent, BusyContainer,Accordion, SvgImage } from '../../../../components';
import { PropTypes } from 'prop-types';
import { configuratorActions, translate } from '../../../../services';
import { DropdownList } from 'react-widgets';
import SelectFilterMessage from './SelectFilterMessage';
import { CloseLightIconNew, FilterIconNew, GreyFilterEmptyIconNew } from '../../../../../style/images';
import { SelectorViewer } from '../productViewer';
import { Badge, Box, Drawer, Icon } from '@mui/material';
import classNames from 'classnames';

const deadValues = ['not applicable', 'not&#032;applicable', 'do not display'];

const containValidValues = variable => {
  return variable.values
    .any( value => value.state !== 4 && !deadValues.includes( value.title.toLocaleLowerCase( 'en-US' ) ) )
};

class ViewItem extends Component {
  render() {
    const { title } = this.props;
    const translated = title;
    return <HtmlComponent className="listbox-content-text" tooltip={ translated } item={ translated } />;
  }
}

const Filter = ( { onChange, name, title, variable, filterType, removeValue } ) => {
  const isSelected = item => item.state === 1;
  const isDefault = item => item.state === 2;
  const isForceable = () => false;
  const changeHandler = item => onChange( item, variable );
  const [selectedValue, setSelectedValue] = useState(null)
  
  const handleSeletedValue = (item)=>{
    setSelectedValue(item)
    onChange( item, variable );
  }

  const valueFilter = value => {
    const translated = value.title;
    //state 3 - blocked values in model
    return value.name.toLowerCase() !== 'not applicable' && value.state !== 4 && value.state !== 3 && translated.toLowerCase() !== 'do not display';
  } 

  const onRemove = () =>{
    setSelectedValue(null);
    removeValue(variable, selectedValue.name, variable.fullyQualifiedName)
  }
  const selectionProps = { 
    isSelected, 
    isDefault, 
    isForceable, 
    onChange: changeHandler, 
    values: variable.values.filter( valueFilter ) };

  // return <Selection
  //   { ...selectionProps }
  //   groupName={ name }
  //   identifier={ variable.name }
  //   pinnable
  //   template={ ViewItem }
  //   title={ title }
  //   isBomItem={ variable.properties.IsBomItem }
  // />;
  return filterType === 2 ? (
    <div className="selection-field">
      <span className="label">{translate(variable.title)}</span>
      <div className="dropdow-container">
        <DropdownList
          data={variable.values.filter(valueFilter)}
          textField="name"
          value={selectedValue}
          onChange={handleSeletedValue}
          placeholder={translate("Select...")}
        />
        <div className="delete-icon">
          <SvgImage 
            source={ CloseLightIconNew } 
            className={ classNames( { 'hidden': !selectedValue } ) } 
            toolTip={ translate( 'Remove assignment' ) }
            onClick={ onRemove }
          />
        </div>
      </div>
    </div>
  ) : (
    <Selection
      {...selectionProps}
      groupName={name}
      identifier={variable.name}
      pinnable
      template={ViewItem}
      title={title}
      isBomItem={variable.properties.IsBomItem}
    />
  );
};

export class AccessoryConfiguratorComponent extends Component {

  constructor(){
    super();
    this.state = {
      toggle:false,
    };
  }
  
  componentDidMount() {
    this.assignCountryValue();
  }

  assignCountryValue() {
    const { products, variables, user } = this.props;
    const allCodes = [];
    for ( let variable of variables ) {
      if( variable.name == 'LSO' && variable.assignedValue?.name !== user.country){
        this.props.assignValue( variable.name, user.country, variable.fullyQualifiedName )
      }
      if ( !variable.properties.IsBomItem ) {
        continue;
      }
      const codes = variable.values
        .filter( value => !products[value.name] && value.name.toLowerCase() !== 'not applicable' && value.state !==4 && value.author !== 0 )
        .map( value => value.name );

      codes.length && allCodes.push( ...codes );
    }
    allCodes.length && this.getProducts( allCodes );
  }

  componentDidUpdate() {
    this.assignCountryValue();
  }

  getProducts( codes ) {
    if ( this.busy ) {
      return;
    }

    this.busy = true;
    this.props.getProducts( codes ).then( () => this.busy = false ).then( () => {
      var filteredCodes = _.chunk( codes.filter( c => this.props.products[c] ), 40 )
      filteredCodes.forEach( pro =>
        this.props.getPrices( pro.map( c => convertToLineItem( this.props.products[c], this.props.user ) ) )
      );
      filteredCodes.forEach( pro =>
        this.props.getStocks(pro.map( c => convertToStockItem(this.props.products[c])))
      );
    } );
  }

  onChange = ( value, variable ) => {
    if ( value.state === 1 || value.state === 2 ) {
      this.props.removeValue( variable.name, value.name, variable.fullyQualifiedName );
    } else {
      this.props.assignValue( variable.name, value.name, variable.fullyQualifiedName );
    }
  }

  getLayout = item => {
    if ( item === null || !item.name || item.obsolete ) {
      return 'unavailable';
    }

    return null;
  }

  isFilterAnyItemSelected = filterItems => {
    const SELECTED_STATE = 1;

    for(const filterItem of filterItems) {
      if (Array.isArray(filterItem?.props?.variable?.values)) {
        for(const item of filterItem.props.variable.values) {
          if (item?.state === SELECTED_STATE) {
            return true;
          }
        }
      }
    }
    return false;
  }

  onToggle = ()=>{
    this.setState({toggle:!this.state.toggle})
  }

  render() {
    if(this.props.currentPage.currentPage!=="accessoryConfiguratorPage"){
      this.props.setPage("accessoryConfiguratorPage")
   }
    const { name, products, variables, currentNode, filterType, typeTwoFilter } = this.props;
    const allRequiredSet = currentNode.customProperties.showAllLooseAccessories;
    let foundProducts = [];
    let accordions = []
    if(allRequiredSet) {
      foundProducts = variables
      .filter( variable => variable.properties.IsBomItem )
      .map( variable => {
        const values = variable.values.filter( value => (value.state === 1 || value.state === 2) && !deadValues.includes( value.name.toLocaleLowerCase( 'en-US' ) ) ) 
        return values?.length ? values : variable.values.filter( value => (value.state === 0) && !deadValues.includes( value.name.toLocaleLowerCase( 'en-US' ) ) ) 
      })
      .flat()
      .map( value => ({ ...products[value.name], '_code': value.name }) ); 
    } else {
      if(filterType===2){
        accordions = typeTwoFilter.map((variable) => {return{name:variable.title, productList:variable.values.filter(value => value.state!==4 && !deadValues.includes( value.name.toLocaleLowerCase( 'en-US' ) ) )
        .flat()
        .map( value => ({ ...products[value.name], '_code': value.name }) )}}); 

        // foundProducts = typeTwoFilter.map(variable => variable.values.filter(value => value.state!==4 && !deadValues.includes( value.name.toLocaleLowerCase( 'en-US' ) ) ))
        // .flat()
        // .map( value => ({ ...products[value.name], '_code': value.name }) ); 
      }
      else{
        foundProducts = variables
        .filter( variable => variable.properties.IsBomItem )
        .map( variable => variable.values
        .filter( value => (value.state === 1 || value.state === 2) && !deadValues.includes( value.name.toLocaleLowerCase( 'en-US' ) ) ) )
        // .filter(value => !deadValues.includes( value.name.toLocaleLowerCase( 'en-US' ) ) ))
        .flat()
        .map( value => ({ ...products[value.name], '_code': value.name }) );
      }   
    }
    
    let filters = []

    filters = variables.filter( variable => variable.name && variable.show && containValidValues( variable ) ).map( variable => {
      const translated = variable.title;

      if (!translated || deadValues.includes( translated.toLocaleLowerCase( 'en-US' ) ) ) {
        return null;
      }

      return <Filter
        key={ translated }
        name={ name }
        onChange={ this.onChange }
        title={ translated }
        variable={ variable }
      />;
    } );

    const filterCount = variables?.filter( variable => variable.name && variable.show && containValidValues( variable ) && !deadValues.includes( variable.title.toLocaleLowerCase( 'en-US' ) )).filter(item => item.values.any(value => [1,2].includes(value.state)))?.length;

    if(filterType===2){
      filters = variables.filter( variable => variable.name && variable.show && containValidValues( variable ) ).filter(variable=>!variable.properties.IsBomItem).map( variable => {
        const translated = variable.title;
  
        if (!translated || deadValues.includes( translated.toLocaleLowerCase( 'en-US' ) ) ) {
          return null;
        }
  
        return <Filter
          key={ translated }
          name={ name }
          onChange={ this.onChange }
          title={ translated }
          variable={ variable }
          filterType={2}
          removeValue = {this.props.removeValue}
        />;
      } );
    }

    return <BusyContainer className="accessory-configurator" actions={ [configuratorActions.ASSIGN, configuratorActions.RESET, configuratorActions.REMOVE, configuratorActions.LOADED] }>
      
      {filterType!==2?
      <div className="looseaccessories-type4-container" style={{height:foundProducts.length>0 ?"100%":this.props.contentHeight}}>
        <Box sx={{height:"100%", width:"100%", display:{md:"flex", xs:"none"}, flexDirection:"column"}}>
          <SelectionViewer>
            { filters }
          </SelectionViewer>
          <ProductsViewer
            products={ foundProducts }
            totalItems={ foundProducts.length }
            tooltip={ null }
            view="looseaccessories"
            currentView= { "ProductsViewer" }
            useCustomLayout={ this.getLayout }
            isFilterSelected={this.isFilterAnyItemSelected(filters)}
            looseAccesories={true}
            currentSelector={this.props.currentSelector}
        />
        </Box>
        <Box sx={{height:"100%", width:"100%", display:{md:"none", xs:"flex"}, flexDirection:"column"}}>
          {/* <SelectionViewer>
            { filters }
          </SelectionViewer> */}
          <div className='filter'>
            <div className='filter-box'>
              <span className='filters-header'>{translate("Filters")}</span>
                <Box sx={{width:"max-content", height:"max-content"}} onClick={this.onToggle}>
                  <Badge badgeContent={filterCount > 0 && <span className="badge">{ filterCount }</span>}>
                    <Icon component="img" src={FilterIconNew} sx={{width:"16px", height:"16px"}}></Icon>
                  </Badge>
                </Box>
            </div>
          </div>
          <ProductsViewer
            products={ foundProducts }
            totalItems={ foundProducts.length }
            tooltip={ null }
            view="looseaccessories"
            currentView= { "ProductsViewer" }
            useCustomLayout={ this.getLayout }
            isFilterSelected={this.isFilterAnyItemSelected(filters)}
            className = {"mobile-grid-view"}
            looseAccesories={true}
            currentSelector={this.props.currentSelector}
        />
        </Box>
      </div>:
      <div className='accessory-configurator-container' style={{height:accordions.any(variable=>variable.productList.length>0 || accordions.length > 0 )?"100%": this.props.contentHeight, width:"100%", minHeight: this.props.contentHeight}}>
        {filters.length>0 && !filters.every(f=>f===null) && <div className="type-2-main-container" style={accordions.length === 0 ? {height: '0'} : {} }><div className="type-2-child-container" style={{height:"100%",width:"100%"}}>{filters}</div></div>}
        <div className={classNames('accordion-container', {'full':filters.length===0 || !filters.every(f=>f===null)})} style={accordions.length === 0 ? {height: '100%', padding:"0px"}: {}}>
          <div style={{height:"100%", width:"100%", overflowY:"auto"}}>
          {
            accordions.length > 0  ?
              accordions.map((variable, key)=> <Accordion key={ key } className="accessory-product-group">
              <h3>{ `${ variable.name } (${ variable.productList.length })` }</h3>
              <ProductsViewer
                products={ variable.productList }
                hideHeader
                totalItems={ variable.productList.length }
                view="looseaccessories"
                currentView= { "ProductsViewer" }
                useCustomLayout={ this.getLayout }
                className = {this.props.screenSize.width<=900?"mobile-grid-view":null}
                currentSelector = {this.props.currentSelector}
              />
            </Accordion>)
            : <SelectFilterMessage heading="No data found." message="There are no accessories found for your request. Please try to change the values in dropdowns" icon={GreyFilterEmptyIconNew} />
        }</div>
      </div>
    </div>
    }
    {/* <SelectionViewer>
        { filters }
      </SelectionViewer>
      <ProductsViewer
        products={ foundProducts }
        totalItems={ foundProducts.length }
        tooltip={ null }
        view="looseaccessories"
        useCustomLayout={ this.getLayout }
      /> */}
      <Drawer
        BackdropProps={{ invisible: true }}
        anchor="bottom"
        open={this.state.toggle}
        onClose={this.onToggle}
        PaperProps={{sx:{height:"100vh", position:"unset"}}}
          >
          <SelectionViewer currentSelector={this.props.currentSelector} resetHeader={this.props.resetHeader} onClose={this.onToggle}>
          { filters }
        </SelectionViewer>
      </Drawer>
    </BusyContainer>;
  }
}

AccessoryConfiguratorComponent.propTypes = {
  assignValue: PropTypes.func.isRequired,
  getProducts: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  products: PropTypes.objectOf( PropTypes.object ),
  removeValue: PropTypes.func.isRequired,
  variables: PropTypes.arrayOf( PropTypes.shape( {
    values: PropTypes.arrayOf( PropTypes.object )
  } ) ).isRequired
};

export const AccessoryConfigurator = connect( combineStates( productState, identityState, currentNodeState,screenSizeState, currentPageState ), combineDispatchers(productsDispatcher, currentPageDispatcher,priceDispatcher,stockDispatcher) )( AccessoryConfiguratorComponent );
